/* @flow */

import React from 'react';

// Components
import FolderIconWrapper from '../FolderIconWrapper';

// Helpers
import modifyItemInFolder from '../../helpers/modifyItemInFolder';

// Types
import type { RelayProp } from 'react-relay';
import type { TrackingHooksType } from '../../types';

type DirectToFolderWrapperProps = {
    additionalIconClass?: string,
    disabledButton: boolean,
    iconPosition: string,
    iconText?: string,
    onAddItemError?: (e: ?Error) => void,
    onAddItemSuccess?: (?{ portfolioName?: string }) => void,
    onFolderClick?: () => void,
    portfolioId: string,
    primaryItemPk: string,
    relay: RelayProp,
    trackingHooks: TrackingHooksType,
    userId: string,
};

export class DirectToFolderWrapper extends React.Component<DirectToFolderWrapperProps> {
    static defaultProps: {
        iconPosition: string,
        loadPortfolioData: boolean,
        disabledButton: boolean,
        trackingHooks: {},
    };

    constructor(props: DirectToFolderWrapperProps) {
        super(props);

        this.modifyItem = this.modifyItem.bind(this);
        this.handleFolderClick = this.handleFolderClick.bind(this);
    }

    modifyItem: () => void;
    handleFolderClick: (e: SyntheticEvent<*>) => void;

    modifyItem() {
        const {
            portfolioId,
            relay,
            userId,
            primaryItemPk,
            trackingHooks,
            onAddItemSuccess,
            onAddItemError,
        } = this.props;

        modifyItemInFolder({
            action: 'ADD',
            portfolioId,
            relay,
            userId,
            primaryItemPk,
            trackingHooks,
            callbacks: {
                onAddItemSuccess,
                onAddItemError,
            },
        });
    }

    handleFolderClick(e: SyntheticEvent<*>) {
        e.preventDefault();
        const trackingHooks = this.props.trackingHooks;

        if (this.props.onFolderClick) {
            this.props.onFolderClick();
        }
        if (trackingHooks.trackFolderClick) {
            trackingHooks.trackFolderClick();
        }
        this.modifyItem();
    }

    render() {
        return (
            <div>
                <FolderIconWrapper
                    additionalIconClass={this.props.additionalIconClass}
                    disabledButton={this.props.disabledButton}
                    iconPosition={this.props.iconPosition}
                    iconText={this.props.iconText}
                    isInFolder={false}
                    onClick={this.handleFolderClick}
                />
            </div>
        );
    }
}

// ignore default prop functions from coverage stats
/* istanbul ignore next */
DirectToFolderWrapper.defaultProps = {
    iconPosition: 'absolute',
    loadPortfolioData: true,
    disabledButton: false,
    trackingHooks: {},
};

export default DirectToFolderWrapper;
